import { CommonModule } from '@angular/common';
import { Component, OnInit, Optional } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { IntegracaoConstants } from 'src/app/constants/integracao';
import { ModulosDeFormulario } from 'src/app/utils/formsModules';
import { FiltroCotacoesRamoService } from '../../filtros/cotacoes-ramo/filtro-cotacoes-ramo.service';
import { Subscription } from 'rxjs';
import { FiltroComponent } from '../../filtro.component';

@Component({
  selector: 'sub-filtro-origem-cotacoes',
  templateUrl: './origem-cotacoes.component.html',
  styleUrls: ['../../filtro.component.scss'],
  imports: [
    CommonModule,
    ModulosDeFormulario,
    MatCheckboxModule,
    MatRadioModule,
    MatMenuModule,
  ],
})
export class OrigemCotacoesComponent implements OnInit {
  protected readonly origemOptions = IntegracaoConstants.integracoesInfo;
  protected filtroOrigem: number | string = '';
  private filtroSubscription: Subscription;

  constructor(
    private filtroCotacoesRamo: FiltroCotacoesRamoService,
    @Optional() private filtroComp?: FiltroComponent
  ) {}

  ngOnInit(): void {
    this.filtroSubscription = this.filtroCotacoesRamo.origem$.subscribe(
      (origem) => (this.filtroOrigem = origem)
    );
  }

  ngOnDestroy(): void {
    this.filtroSubscription.unsubscribe();
  }

  onFiltroChange(newValue: number) {
    this.filtroOrigem = newValue;
    this.filtroCotacoesRamo.changeOrigem(newValue);

    this.filtroComp?.sendFilter(false);
  }

  onRadioClick(event: MouseEvent, value: string | number) {
    if (this.filtroOrigem === value) {
      event.preventDefault();
      this.filtroOrigem = '';
      this.filtroCotacoesRamo.changeOrigem('');
    }

    this.filtroComp?.sendFilter(false);
  }
}
